import styled from 'styled-components'
import {Button, Icon, Loading} from 'startlibs/lib/components'
import {getColor} from 'startlibs/lib/lib'

export const PageContainer = styled.div`
  max-width: 40rem;
  margin: 0 auto;
  padding: 4rem 1rem 2rem;
  min-height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`
export const PageCard = styled.div`
  background-color: white;
  border-radius: 5px;
  box-shadow: 0 0 4px 0 rgba(0,0,0,.25);
  text-align: center;
  color: rgba(0,0,0,0.6);
  position: relative;
  margin: 6rem 0;
  h2 {
    color: ${getColor('main')};
    margin-bottom: .5rem;
    font-size: 21px;
    &.error-title {
      color: ${getColor('alert')};
    }
  }
  .main-text {
    font-size: 14px;
    margin: 0 auto 1rem;
  }
  .download-text {
    max-width:  12rem;
  }
  .patient-name {
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 10px;
    margin-top: -.25rem;
  }
  .card-note {
    margin-top: 1rem;
    color: rgba(0,0,0,0.5);
  }
  form {
    margin-top: 1.5rem;
  }
  label {
    text-align: left;
    display: block;
    color: ${getColor('gray90')};
  }
  .post-field-description {
    margin-bottom: 2rem;
  }
  ${Button} {
    min-width: 130px;
    margin-top: 1rem;
  }
  li {
    text-align: left;
  }
`
export const CardContent = styled.div`
  padding: 6rem 3rem 3rem;
  position: relative;
`
export const CardIcon = styled.div`
  position: absolute;
  top: 0;
  left: 50%;
  transform: translate(-50%,-50%);
  img {
    width: 110px
  }
  ${Icon} {
    position: absolute;
    bottom: -6px;
    right: -6px;
    font-size: 26px;
    background: white;
    border-radius: 50%;
    width: 32px;
    height: 32px;
    line-height: 32px;
    padding-left: 1px;
    text-align: center;
    box-shadow: 0 0 4px 0 rgba(0,0,0,0.25);
  }
`
export const ErrorIcon = styled(Icon)`
  color: white;
  font-size: 50px;
  line-height: 60px;
  background: ${getColor('alert')};
  border-radius: 50%;
  height: 60px;
  width: 60px;
  display: block;
  text-align: center;
  margin: 2rem auto;
`
export const SuccessIcon = styled(ErrorIcon)`
  background: white;
  color: ${getColor('main')};
  line-height: 56px;
  border: 4px solid ${getColor('main')};
`
export const DownloadLoading = styled(Loading)`
  margin: 2rem auto;
`
export const PageFooter = styled.div`
  text-align: center;
  color: rgba(0,0,0,0.4);
  a {
    color: inherit;
    font-weight: 600;
    font-size: 13px;
    ~ a {
      margin-left: 0.5rem;
    }
    :hover {
      color: ${getColor('main')};
    }
  }
`



// WEBPACK FOOTER //
// ./src/javascripts/shareModule/SharingComponents.jsx